import { useEffect } from 'react';

import { useLocalSearchParams, useRouter } from 'expo-router';
import { StyleSheet, View } from 'react-native';

import { CardModal } from 'components/card-modal';
import { QuestTerms } from 'components/quests/quest-drawer-content/quest-terms';
import { useGetCmsQuestDetailByIdQuery } from 'generated/sanity-graphql';
import { routes } from 'navigation/routing';
import LoyaltyLoader from 'pages/loyalty/loyalty-loader/loyalty-loader';
import { t } from 'state/intl/translations';
import { spacing } from 'styles/constants';

export default function QuestTermsModal() {
  const { cmsId } = useLocalSearchParams<{ cmsId: string }>();
  const router = useRouter();

  const { data, loading } = useGetCmsQuestDetailByIdQuery({
    variables: { swQuestId: cmsId ?? '', requirementIds: [] },
  });

  const moreInfo = data?.SystemwideQuest?.moreInfo;
  const hasTerms = !!moreInfo?.localeRaw;

  useEffect(() => {
    if (!loading && !hasTerms) {
      router.canDismiss() ? router.dismiss() : router.replace(routes.base);
    }
  }, [loading, hasTerms, router]);

  if (loading || !hasTerms) {
    return (
      <CardModal headerText={t('termsConditions')} isLoading>
        <LoyaltyLoader />
      </CardModal>
    );
  }

  return (
    <CardModal headerText={t('termsConditions')} scrollView>
      <View style={styles.content}>
        <QuestTerms cmsQuestTerms={moreInfo} hideHeading />
      </View>
    </CardModal>
  );
}

const styles = StyleSheet.create({
  content: {
    paddingHorizontal: spacing.$4,
    paddingVertical: spacing.$6,
  },
});
